import React from "react";
import LegalLayout from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terma Penggunaan">
      <p className="text-sm text-gray-500">Kemas kini terakhir: Februari 2026</p>
      <p>Dengan menggunakan TAi-P (Tripstar Ai Planner), anda bersetuju dengan terma di bawah.</p>

      <h2>1. Penggunaan yang Dibenarkan</h2>
      <ul>
        <li>Untuk perancangan perjalanan peribadi atau perniagaan yang sah.</li>
        <li>Tidak menggunakan apl untuk aktiviti yang menyalahi undang-undang, penipuan, atau merosakkan sistem kami.</li>
        <li>Tidak menyalahguna, membalikkan kejuruteraan, atau mengkomersialkan output apl tanpa kebenaran.</li>
      </ul>

      <h2>2. Penafian AI</h2>
      <p>Cadangan TAi-P dijana oleh AI dan mungkin tidak tepat, tidak lengkap atau lapuk. Anda bertanggungjawab untuk mengesahkan maklumat sebelum membuat sebarang keputusan perjalanan.</p>

      <h2>3. Maklumat Perjalanan / Hotel / Penerbangan / Harga</h2>
      <p>Ketersediaan hotel, harga, jadual penerbangan, waktu operasi, status halal, cuaca dan maklumat lain adalah anggaran. Sila semak semula dengan pembekal rasmi sebelum menempah.</p>

      <h2>4. Had Liabiliti</h2>
      <p>TAi-P disediakan "sebagaimana adanya" tanpa jaminan. Kami tidak bertanggungjawab atas kerugian, kehilangan tempahan, kelewatan, atau kerosakan yang timbul daripada penggunaan cadangan yang diberikan.</p>

      <h2>5. Tanggungjawab Pengguna</h2>
      <ul>
        <li>Menjaga kerahsiaan kata laluan akaun anda.</li>
        <li>Mematuhi undang-undang negara destinasi.</li>
        <li>Menyemak visa, pasport, insurans dan keperluan kesihatan.</li>
      </ul>

      <h2>6. Harta Intelek</h2>
      <p>Semua logo, jenama, kod, reka bentuk dan sistem AI TAi-P adalah hak milik Tripstar. Itinerari yang dijana adalah untuk kegunaan peribadi anda.</p>

      <h2>7. Pembelian Premium (Apple In-App Purchase)</h2>
      <ul>
        <li>TAi-P menawarkan pembelian <b>satu kali</b> ("TAi-P Full Access") melalui Apple App Store. Tiada langganan bulanan atau tahunan.</li>
        <li>Pembayaran diuruskan oleh Apple. Sila rujuk polisi bayaran balik Apple.</li>
        <li>Pembelian mengunci ciri penuh untuk selama-lamanya bagi akaun yang membeli.</li>
        <li>Fungsi <i>Restore Purchases</i> tersedia untuk memasang semula pada peranti lain di bawah Apple ID yang sama.</li>
      </ul>

      <h2>8. Penamatan</h2>
      <p>Kami boleh menggantung akaun yang melanggar terma ini. Anda boleh memadam akaun anda pada bila-bila masa melalui Tetapan.</p>

      <h2>9. Undang-undang</h2>
      <p>Terma ini ditadbir mengikut undang-undang Malaysia. Sebarang pertikaian akan diselesaikan di mahkamah Kuala Lumpur.</p>

      <h2>10. Hubungi</h2>
      <p>E-mel: <a href="mailto:support@tripstera.app">support@tripstera.app</a></p>
    </LegalLayout>
  );
}
